<template>
  <div
    class="row"
  >
    <q-select
      v-model="selectedColorName"
      class="col"
      :options="colorOptions"
      map-options
      emit-value
      :clearable="clearable"
      :disable="disable"
      :label="label"
    >
      <q-tooltip v-if="!!tooltip">
        {{ tooltip }}
      </q-tooltip>
    </q-select>
    <div
      class="col"
      :class="compactView ? 'q-ml-sm' : 'q-ml-md'"
    >
      <color-picker
        :color-name="selectedColorName"
        :color-hex="selectedColorHex"
        :disable="disable"
        @update:model-value="handleCustomColorHex"
      />
    </div>
  </div>
</template>

<script>
import { colorOptions as defaultColorOptions } from 'src/models/page/Section'
import ColorPicker from 'src/modules/admin/components/ColorPicker'

export default {
  name: 'ColorSelection',
  components: {
    ColorPicker
  },
  props: {
    colorName: {
      type: String,
      required: false,
      default: null
    },
    customColorHex: {
      type: String,
      required: false,
      default: null
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'Color'
    },
    tooltip: {
      type: String,
      required: false,
      default: null
    },
    colorOptions: {
      type: Array,
      required: false,
      default: defaultColorOptions
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    compactView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      selectedColorName: this.colorName,
      selectedColorHex: this.customColorHex
    }
  },
  watch: {
    selectedColorName () {
      this.$emit('update:model-value', this.selectedColorName, this.selectedColorHex)
    },
    selectedColorHex () {
      this.$emit('update:model-value', this.selectedColorName, this.selectedColorHex)
    }
  },
  methods: {
    handleCustomColorHex (colorHex) {
      this.selectedColorHex = colorHex
    }
  }
}
</script>
